import 'date-fns';
import * as React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { isNullOrUndefined } from 'util';

interface IDatePickerProps {
    label: string;
    valueKey: string;
    updateValue: (key: string, value: Date) => void;
    date: Date | undefined;
    margin?: Margin;
    endDate?: Date;
}

type Margin = 'none' | 'dense' | 'normal';

const MaterialUIPickers: React.SFC<IDatePickerProps> = (props) => {
    function handleDateChange(date: Date | null) {
        if (date !== null && props.updateValue && props.valueKey) {
            props.updateValue(props.valueKey, date);
        }
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                margin={props.margin ? props.margin : "normal"}
                id={props.valueKey}
                label={props.label}
                value={!isNullOrUndefined(props.date) ? props.date : new Date()}
                onChange={handleDateChange}
                format="dd/MM/yyyy"
                autoOk
                fullWidth
                inputVariant="outlined"
                className=""
                ref={null}
                innerRef={null}
                style={undefined}
                onBlur={undefined}
                onFocus={undefined}
                rows={1}
                rowsMax={1}
                maxDate={props.endDate}
            />
        </MuiPickersUtilsProvider>
    );
}

export default MaterialUIPickers;